import React from 'react';
import * as Icons from '../icons/AllIconsSvg';
import { Box, Chip, Grid2, Typography } from '@mui/material';
import DevicesIcon from '@mui/icons-material/Devices';
import CodeIcon from '@mui/icons-material/Code';
import TerminalIcon from '@mui/icons-material/Terminal';

const skills = {
    frontend: [
        { name: 'CSS', Icon: Icons.CssIcon },
        { name: 'HTML', Icon: Icons.HTMLIcon },
        { name: 'JavaScript', Icon: Icons.JavaScriptIcon },
        { name: 'TypeScript', Icon: Icons.TypescriptIcon },
        { name: 'Next.js', Icon: Icons.NextJsIcon },
        { name: 'React', Icon: Icons.ReactIcon },
        { name: 'React Native', Icon: Icons.ReactIcon },
        { name: 'Redux', Icon: Icons.ReduxIcon },
        { name: 'Figma', Icon: Icons.FigmaIcon },
        { name: 'Material UI', Icon: Icons.MaterialUiIcon },
    ],
    backend: [
        { name: 'NestJS', Icon: Icons.NestJsIcon },
        { name: 'Node.js', Icon: Icons.NodeJsIcon },
        { name: 'MySQL', Icon: Icons.MysqlIcon },
        { name: 'PostgreSQL', Icon: Icons.PostgresqlIcon },
        { name: 'Java', Icon: Icons.JavaIcon },
    ],
    otherTools: [
        { name: 'Android Studio', Icon: Icons.AndroidStudioIcon },
        { name: 'Argo', Icon: Icons.ArgoIcon },
        { name: 'Docker', Icon: Icons.DockerIcon },
        { name: 'Git', Icon: Icons.GitIcon },
        { name: 'GitHub', Icon: Icons.GithubIcon },
        { name: 'Jest', Icon: Icons.JestIcon },
        { name: 'Kubernetes', Icon: Icons.KubernetesIcon },
        { name: 'Linux', Icon: Icons.LinuxIcon },
        { name: 'Postman', Icon: Icons.PostmanIcon },
        { name: 'Rancher', Icon: Icons.RancherIcon },
    ],
};

const iconsCategory = {
    Frontend: <DevicesIcon color="warning" />,
    Backend: <TerminalIcon color="warning" />,
    Outros: <CodeIcon color="warning" />,
};

const SkillsCategory = ({ category, skills }) => (
    <Box sx={{ maxWidth: '700px' }} m="auto" mb={4}>
        <Box
            sx={{
                marginY: 2,
                marginX: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Chip icon={iconsCategory[category]} label={category} variant="outlined" />
        </Box>

        <Grid2 container spacing={2} justifyContent="center">
            {skills.map((skill) => (
                <Grid2 item xs={6} sm={4} md={3} lg={3} xl={3} key={skill.name}>
                    <Box
                        textAlign="center"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '120px',
                        }}
                    >
                        <skill.Icon style={{ width: 40, height: 40 }} />
                        <Typography
                            variant="body1"
                            sx={{
                                width: '100%',
                                textAlign: 'center',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                            fontWeight={500}
                        >
                            {skill.name}
                        </Typography>
                    </Box>
                </Grid2>
            ))}
        </Grid2>
    </Box>
);

const Skills = ({ darkMode }) => (
    <Box sx={{ backgroundColor: darkMode ? '#0E0E0FC3' : '#FFFFFF88', paddingY: 2 }}>
        <Typography variant="h2" textAlign="center" mb={2} fontWeight={500}>
            {'Stacks'}
        </Typography>
        <SkillsCategory category="Frontend" skills={skills.frontend} />
        <SkillsCategory category="Backend" skills={skills.backend} />
        <SkillsCategory category="Outros" skills={skills.otherTools} />
    </Box>
);

export default Skills;
